import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import useWindowWidth from '../../hooks/useWindowSize';

const CitiesList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-top: 32px;
  margin-bottom: 0;
  text-align: left;

  li {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
    font-family: Poppins, sans-serif;
    color: #253ec6;
    padding-bottom: 16px;
    width: 80%;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  li:not(:last-of-type) {
    border-bottom: 1px solid #d8d8d8;
  }
`;

function Cities() {
  const {width } = useWindowWidth();
  return (
    <section className="how_it_works container">
      <h2 className="headline-2 center w-100">
        Cities we serve in New York City
      </h2>
      <div className="row" style={{ alignItems: 'center', marginTop: width > 600 ? 96 : 48, gap:  width < 768 ? 32 : "auto" }}>
        <div className="col-xs-12 col-md-4">
          <CitiesList>
            <li>
              <Link to="/house-cleaning-services-brooklyn">Brooklyn</Link>
            </li>
            <li>
              <Link to="/house-cleaning-services-manhattan">Manhattan</Link>
            </li>
            <li>
              <Link to="/house-cleaning-services-queens">Queens</Link>
            </li>
          </CitiesList>
        </div>
        <div className="col-xs-12 col-md-8">
          <img src={require('../../assets/cities.png')} alt="cities" />
        </div>
      </div>
    </section>
  );
}

export default Cities;